// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import SortableController from "stimulus-sortable"

import { application } from "./application"

import TransitionController from "./transition_controller"
import TransitionGroupController from "./transition_group_controller"
import DropdownController from "./dropdown_controller"
import CoordPicker from "./coord_picker_controller"
import NestedFormController from "./nested_form_controller"

application.register("sortable", SortableController)
application.register("transition", TransitionController)
application.register("transition-group", TransitionGroupController)
application.register("dropdown", DropdownController)
application.register("coord-picker", CoordPicker)
application.register("nested-form", NestedFormController)
